import React from 'react';
import { useConfiguratorsList } from './hooks';
import { InstallationCard, MeasureCard } from './components';
import { ConfiguratorsListContainer } from './styled';

export const ConfiguratorsList = () => {
	const { configurators } = useConfiguratorsList();
	const numberOfMeasureConfigurators = configurators.filter(({ type }) => type === 'measurement')
		.length;

	const isAvailableToOrder = configurators?.some(({ isAvailable }) => isAvailable);

	return (
		<ConfiguratorsListContainer>
			{!!configurators.length &&
				configurators.map((configurator, i) => {
					const isWide =
						isAvailableToOrder &&
						configurators[i - 1]?.type === 'measurement' &&
						numberOfMeasureConfigurators % 2 === 1;

					if (configurator.type === 'measurement' && !isAvailableToOrder) {
						return null;
					}

					return configurator.type === 'measurement' ? (
						<MeasureCard
							key={`measurement-card-${configurator.id}`}
							configurator={configurator}
							wide={true}
						/>
					) : (
						<InstallationCard
							key={`installation-card-${configurator.id}`}
							configurator={configurator}
							wide={isWide}
							position={i + 1}
						/>
					);
				})}
		</ConfiguratorsListContainer>
	);
};
